"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitEvent = void 0;
var state_1 = require("./state");
var emitEvent = function (event) {
    var state = (0, state_1.getState)();
    if (!event.eventType) {
        throw "Invalid arguments: an event must have an event type";
    }
    if (!event.eventName) {
        throw "Invalid arguments: an event must have an event name";
    }
    //If unassigned, generate a unique id based on eventName/eventType:
    if (!event.uniqueEventId) {
        event = __assign(__assign({}, event), { uniqueEventId: "".concat(event.eventName, "/").concat(event.eventType) });
    }
    //If `sessionId` is null it means it's a legacy app (SPX).
    var isLegacyApp = !event.sessionId;
    var existingEvent = isLegacyApp ?
        state.eventQueue.find(function (_) { return _.uniqueEventId === event.uniqueEventId && _.isSuspended; }) :
        state.eventQueue.find(function (_) { return _.uniqueEventId === event.uniqueEventId && _.sessionId == event.sessionId; });
    if (existingEvent) {
        if (existingEvent.isSuspended) {
            handleSuspendedEvent(event, existingEvent);
            return;
        }
        else if (!isLegacyApp) {
            //This means we have a duplicate event from the same session - therefore we need to ignore the event.
            //SPX doesn't use sessionId, so ignoring this return for SPX.
            return;
        }
    }
    state.eventQueue.push(event);
    if (!state.eventQueue.find(function (_) { return _.isSuspended; })) {
        sinkEvent(event);
    }
};
exports.emitEvent = emitEvent;
var handleSuspendedEvent = function (modifiedEvent, suspendedEvent) {
    if (modifiedEvent.isSuspended) {
        //We can suspend the same event as many times as we want.
        return;
    }
    var state = (0, state_1.getState)();
    var index = state.eventQueue.indexOf(suspendedEvent);
    state.eventQueue[index] = mergeEvents(modifiedEvent, suspendedEvent);
    for (var i = index; i < state.eventQueue.length; i++) {
        if (state.eventQueue[i].isSuspended) {
            break;
        }
        sinkEvent(state.eventQueue[i]);
    }
};
var sinkEvent = function (event) {
    var state = (0, state_1.getState)();
    var modifiedEvent = state.middlewares.reduce(function (e, middleware) { return middleware.handler(e); }, event);
    state.sinks.forEach(function (_) { return _.handler(modifiedEvent); });
};
var mergeEvents = function (modifiedEvent, suspendedEvent) {
    return __assign(__assign({}, modifiedEvent), { eventData: __assign(__assign({}, suspendedEvent.eventData), modifiedEvent.eventData) });
};
